import { Injectable, inject } from '@angular/core';
import {Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../environments/environment';
import {map} from 'rxjs/operators';
import {Page, PageDto} from '../core/pagination/page';
import {PageRequest} from '../core/pagination/page-request';
import {Therapeut, TherapeutDto} from './therapeut';

@Injectable({
  providedIn: 'root'
})
export class TherapeutService {
  private http = inject(HttpClient);

  getTherapeutMe$(): Observable<Therapeut> {
    return this.http
      .get<TherapeutDto>(`${environment.apiUrl}/therapeuten/me`)
      .pipe(map(dto => Therapeut.deserialize(dto)));
  }

  getTherapeuten$(pageRequest: PageRequest<Therapeut>): Observable<Page<Therapeut>> {
    return this.http
      .post<PageDto<TherapeutDto>>(`${environment.apiUrl}/therapeuten/page`, pageRequest)
      .pipe(map(pageDto => new Page(
        pageDto.ascending,
        pageDto.pageSize,
        pageDto.pageNumber,
        pageDto.lastPage,
        pageDto.items.map(dto => Therapeut.deserialize(dto)),
      )));
  }

  getTherapeutenByIds$(therapeutIds: Array<{ id: string, nummer: string }>): Observable<Array<Therapeut>> {
    return this.http.post<Array<TherapeutDto>>(`${environment.apiUrl}/therapeuten/ids`, {ids: therapeutIds.map(id => id.id)})
      .pipe(map(therapeutDtos => this.getTherapeuten(therapeutIds, therapeutDtos)));
  }

  getTherapeuten(therapeutIds: Array<{ id: string, nummer: string }>, therapeutDtos: Array<TherapeutDto>): Array<Therapeut> {
    const therapeuten = therapeutDtos.map(dto => Therapeut.deserialize(dto));
    return therapeutIds.map(therapeutId =>
      therapeuten.find(therapeut => therapeut.hasId(therapeutId.id))
      || Therapeut.verwijderd(therapeutId.id, therapeutId.nummer)
    );
  }

  postTherapeut$(therapeut: Therapeut): Observable<Therapeut> {
    return this.http
      .post<TherapeutDto>(`${environment.apiUrl}/therapeuten`, therapeut)
      .pipe(map(dto => Therapeut.deserialize(dto)));
  }

  getTherapeutById$(id: string): Observable<Therapeut> {
    return this.http.get<TherapeutDto>(`${environment.apiUrl}/therapeuten/${id}`)
      .pipe(map(dto => Therapeut.deserialize(dto)));
  }

  updateTherapeut$(therapeut: Therapeut): Observable<Therapeut> {
    return this.http.put<TherapeutDto>(`${environment.apiUrl}/therapeuten/${therapeut.getId()}`, therapeut)
      .pipe(map(dto => Therapeut.deserialize(dto)));
  }

  deleteTherapeut$(id: string): Observable<void> {
    return this.http.delete<void>(`${environment.apiUrl}/therapeuten/${id}`);
  }
}
